import { useSelector } from "react-redux";
import { selectedBMSRState, selectedRidersState } from "../../features/gms-proposal-forms/attachable-rider/attachable-riders.slice";
import { selectLevelRankingRiders } from "../../features/gms-proposal-forms/coverage/level-ranking/coverage-type-level-ranking.slice";
import { PROPOSAL_RIDERS } from "../../constant/gms-constant";

export const useRidersForLevelRanking = () => {

    const selectedRiders = useSelector(selectedRidersState) ?? [];
    const selectedBMSR = useSelector(selectedBMSRState);
    const selectLevelRankingRidersState = useSelector(selectLevelRankingRiders);
    const amountBMSR = selectedBMSR?.inputs?.[0]?.fAmount ?? 0;

    const isSelected = (id: number) => selectedRiders.some(r => r.id === id);

    const staticRiders = [
        (isSelected(PROPOSAL_RIDERS.BMSR.productFor.GCI) || isSelected(PROPOSAL_RIDERS.BMSR.productFor.GYRT)) && {
            rider_id: isSelected(PROPOSAL_RIDERS.BMSR.productFor.GCI)
                ? Number(PROPOSAL_RIDERS.BMSR.productFor.GCI)
                : Number(PROPOSAL_RIDERS.BMSR.productFor.GYRT),
            values: [{ amount: amountBMSR }],
        },
    ].filter(
        (rider): rider is { rider_id: number; values: { amount: number }[] } => Boolean(rider),
    );

    const staticRiderIds = staticRiders.map(rider => rider.rider_id);

    const dynamicRiders = selectedRiders
        .filter(rider => !staticRiderIds.includes(rider.id))
        .map(rider => {
            const matchedRider = selectLevelRankingRidersState?.find(
                item => item.id === rider.id
            );

            const values = matchedRider?.inputs?.map(input => ({
                designation: input.label,
                amount: input.fAmount
            })) ?? [];

            return {
                rider_id: rider.id,
                values
            };
        });

    return [...dynamicRiders, ...staticRiders];
};
